import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, FileText, Shield, Users } from "lucide-react";
import { getSiblingPolicyPages } from "../../utils/policyDeskHelpers";

const PAGE_ICONS = {
  privacy: Shield,
  terms: FileText,
  community: Users,
};

const PolicyDeskSiblingNav = ({ currentId }) => {
  const siblings = getSiblingPolicyPages(currentId);

  return (
    <nav className="pp-sibling-nav-card" aria-label="Related policies">
      <p className="pp-sibling-nav-label">Also read</p>
      <ul className="pp-sibling-nav-list">
        {siblings.map((page) => {
          const Icon = PAGE_ICONS[page.id] || FileText;
          return (
            <li key={page.id}>
              <Link to={page.path} className="pp-sibling-nav-link">
                <span className="pp-sibling-nav-icon" aria-hidden>
                  <Icon size={12} />
                </span>
                <span className="pp-sibling-nav-copy">
                  <strong>{page.title}</strong>
                  <span>{page.teaser}</span>
                </span>
                <ArrowUpRight size={12} className="pp-sibling-nav-arrow" aria-hidden />
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default PolicyDeskSiblingNav;
